/**
 * @generated SignedSource<<c66c3c0750ae968bf7ff9b95661a204a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotoLikesLoader_searchResult$data = {
  readonly project: {
    readonly tradePhotos: ReadonlyArray<{
      readonly url: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PhotoLikesLoader_searchResult";
};
export type PhotoLikesLoader_searchResult$key = {
  readonly " $data"?: PhotoLikesLoader_searchResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotoLikesLoader_searchResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotoLikesLoader_searchResult",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "designProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhoto",
          "kind": "LinkedField",
          "name": "tradePhotos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeInteriorProjectQueryOutput",
  "abstractKey": null
};

(node as any).hash = "b8706d4622b687bc1595ab2a34cf59d2";

export default node;
